document.addEventListener("DOMContentLoaded", function() {

	var $ = jQuery.noConflict();

    $("footer .menu-list").each(function() {
        $("h3").click(function(){           
            var item = $( this ).parent( '.item' );   
            $("footer .item").removeClass("open");
            item.toggleClass( 'open' );
        });        
    });
});